export const APP_VERSION = "0.1.0";
export const CREATOR_LABEL = "서버포럼 - 빨간물약";
export const GUIDE_URL = "https://svrforum.com/article_series/dispArticle_seriesView?series_id=95";
